import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Index from "./pages/Index";

const EntryDetail = lazy(() => import("./pages/EntryDetail"));
const WhatIsNercCip = lazy(() => import("./pages/WhatIsNercCip"));
const HowToUse = lazy(() => import("./pages/HowToUse"));
const CipStandards = lazy(() => import("./pages/CipStandards"));
const CipStandardDetail = lazy(() => import("./pages/CipStandardDetail"));
const NercCipConsulting = lazy(() => import("./pages/NercCipConsulting"));
const NercCip2026Report = lazy(() => import("./pages/NercCip2026Report"));
const NercCipLowImpact = lazy(() => import("./pages/NercCipLowImpact"));
const NercCipInsm = lazy(() => import("./pages/NercCipInsm"));
const NercCipCloudSecurity = lazy(() => import("./pages/NercCipCloudSecurity"));
const NercCipSupplyChain = lazy(() => import("./pages/NercCipSupplyChain"));
const NercCipGridTransformation = lazy(() => import("./pages/NercCipGridTransformation"));
const NercCipAuditGuide = lazy(() => import("./pages/NercCipAuditGuide"));
const NercCipBuyingGuide = lazy(() => import("./pages/NercCipBuyingGuide"));
const CategoryPage = lazy(() => import("./pages/CategoryPage"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-background" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/what-is-nerc-cip" element={<WhatIsNercCip />} />
            <Route path="/how-to-use" element={<HowToUse />} />
            <Route path="/cip-standards" element={<CipStandards />} />
            <Route path="/cip/:cipId" element={<CipStandardDetail />} />
            <Route path="/entry/:id" element={<EntryDetail />} />
            <Route path="/nerc-cip-consulting" element={<NercCipConsulting />} />
            <Route path="/nerc-cip-2026-report" element={<NercCip2026Report />} />
            <Route path="/nerc-cip-low-impact" element={<NercCipLowImpact />} />
            <Route path="/nerc-cip-insm" element={<NercCipInsm />} />
            <Route path="/nerc-cip-cloud-security" element={<NercCipCloudSecurity />} />
            <Route path="/nerc-cip-supply-chain" element={<NercCipSupplyChain />} />
            <Route path="/nerc-cip-grid-transformation" element={<NercCipGridTransformation />} />
            <Route path="/nerc-cip-audit-guide" element={<NercCipAuditGuide />} />
            <Route path="/nerc-cip-buying-guide" element={<NercCipBuyingGuide />} />
            <Route path="/category/:slug" element={<CategoryPage />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
